export default "__VITE_ASSET__Dm4qoKhg__"